import React, { useEffect, useMemo, useRef, useState } from 'react'

// Real world backgrounds:
import { ReactComponent as RealWorldSvgOne } from '../../assets/svgs/real-world-01.svg'
import { ReactComponent as RealWorldSvgTwo } from '../../assets/svgs/real-world-02.svg'
import { ReactComponent as RealWorldSvgThree } from '../../assets/svgs/real-world-03.svg'


const StoryRealWorld = ({ index, relatedRealWorlds, color, isMobile = false, inActive = null, locationName, onSetActiveSectionNum }) => {
    const [isIntersecting, setIsIntersecting] = useState(false)
    const ref = useRef(null)

    const observer = useMemo(() =>
        new IntersectionObserver(([entry]) => setIsIntersecting(entry.isIntersecting), { threshold: 0, rootMargin: '-50% 0px -50% 0px' }
        ), [])

    useEffect(() => {
        observer.observe(ref.current)
        return () => {
            observer.disconnect()
        }
    }, [ref, observer])

    useEffect(() => {
        if (isIntersecting && onSetActiveSectionNum) {
            onSetActiveSectionNum(index)
        }
    }
    , [index, isIntersecting])

    const renderRealWorldStories = () => {
        const totalItems = relatedRealWorlds.length
        let allStories = []
        relatedRealWorlds.forEach((realStory, idx) => {
            // cycle through the 3 svgs for variety based on the idx
            let SvgComponent = RealWorldSvgOne // default
            if (idx % 3 === 1) {
                SvgComponent = RealWorldSvgTwo
            } else if (idx % 3 === 2) {
                SvgComponent = RealWorldSvgThree
            }
            allStories.push(
                <div className={`real-world-story ${color}`} key={`real-world-${idx}`}>
                    <SvgComponent />
                    <a
                        key={idx}
                        href={realStory.source_link.uri}
                        target="_blank"
                        className="real-world-story-background"
                        style={{ backgroundImage: `url(${realStory.thumbnail.url})` }}
                        alt={realStory.thumbnail.alt}
                        rel="noreferrer">
                        <div className="story-title">
                            <h3>{realStory.title}</h3>
                            <span>{realStory.real_world_location}</span>
                        </div>
                    </a>
                </div>
            )
        })
        return (
            <div className="stories-wrapper">
                <h2>Learn about real stories that inspired<br/>{locationName}</h2>
                <div className={`real-world-tiles count-${totalItems}`}>
                    {allStories}
                </div>
            </div>
        )
    }

    return (
        <div ref={ref} className="container" id={`section-${index}`}>
            {renderRealWorldStories()}
        </div>
    )
}

export default StoryRealWorld
